import { requisitarJson } from '../../../shared/api/http';

export interface TextoDaTela {
    chave: string;
    tela: string;
    rotulo: string;
    /** Texto original do aplicativo. */
    padrao: string;
    /** `null`: vale o padrão. */
    valor: string | null;
    /** Variáveis `{assim}` que o texto precisa manter. */
    variaveis: string[];
}

export interface TextoAlterado extends TextoDaTela {
    alterado: boolean;
}

export function listarTextos(): Promise<TextoDaTela[]> {
    return requisitarJson('/api/v1/textos');
}

/** `valor: null` restaura o padrão do aplicativo. */
export function alterarTexto(chave: string, valor: string | null, valorAnterior: string | null, csrfToken: string): Promise<TextoAlterado> {
    return requisitarJson(`/api/v1/textos/${encodeURIComponent(chave)}`, {
        method: 'PATCH',
        csrfToken,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ valor, valor_anterior: valorAnterior }),
    });
}
